/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import {LoadingModalBody} from "./LoadingModalBody";
import React from "react";
import {ObsoleteProductBody} from "./ObsoleteProductBody";
import {ProductModalBody} from "./ProductModalBody";
import {Modal} from "../../atoms/bootstrap/Modal";
import {hasRole, ROLES} from "../../../data/user.model";
import {ModalWarning} from "./ModalWarning";
import {useI18N} from "../../hoc/withI18N";
import {useDispatch, useSelector} from "react-redux";
import {selectIsPricingVatIncluded} from "../../../selectors/my-puratos/account";
import {closeModal} from "../../../actions/modals";
import {getAEMResource, getHomepageModel, getRoleBasedConfiguration} from "../../../selectors/generic";

export function ProductModal({skus, loading, title, children, addAll = undefined}) {

    const translate = useI18N();
    const isPricingVatIncluded = useSelector(state => selectIsPricingVatIncluded(state));
    const roleBased = useSelector(state => getRoleBasedConfiguration(state));
    const homepage = useSelector(state => getAEMResource(state, getHomepageModel()));

    const dispatch = useDispatch();
    const close = React.useCallback(() => dispatch(closeModal()), [dispatch, closeModal]);

    if (!hasRole(ROLES.valid)) {
        return <ModalWarning roleBased={roleBased} closeModal={close}/>
    }

    if (loading) {
        return <Modal size={Modal.sizes.XL} title={translate(title)} closeModal={close}>
            <LoadingModalBody/>
        </Modal>
    }

    if (!skus || skus.length === 0) {
        return <Modal size={Modal.sizes.XL} title={translate(title)} closeModal={close}>
            <ObsoleteProductBody homepage={homepage}/>
        </Modal>
    }

    return <Modal size={Modal.sizes.XL} title={translate(title)} closeModal={close}>
        <ProductModalBody isPricingVatIncluded={isPricingVatIncluded} addAll={addAll}>
            {children}
        </ProductModalBody>
    </Modal>
}
